module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAWCAYAAAAinad/AAAA/UlEQVQ4T7WUMS8GQRRFz4p8iU4hSp0EnVpB6ReIEo1Ko6AgCg2JIOEHH7mykjXZzdrZz6smmcnJu2/ufQ1LKHUPeG3msNR14AG4AlarYOoKcAk8Ahs/DU2GqUfAG7BfqvozTN0CXoCTodGMwtQ14A64BnIerEGYmrtT4BlIV6PVC1Mzj0/gYJTQefALpm4CT8AZkB+bVN8wddF65R6Id6qqUY+BD2C7itCV2cLegZ3ZsKXK7HajJhqxwnn1B5TyWmtE+uEU6f9v2kJ6InQL3FTHqUd6IpV5JmK9ikaD3gOdv4IK6YnaRRu9+uVYQBO9RDBrezFZZp9V1N1s3y9PRlcv0rFBdQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/left.png
// module id = xDWF
// module chunks = 1